var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('row',{staticClass:"ln-agree-register link-wrap"},[_c('Checkbox',{attrs:{"shape":"square","icon-size":16},model:{value:(_vm.agree),callback:function ($$v) {_vm.agree=$$v},expression:"agree"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }